import React from 'react';

import p4Icon from '@images/spe-low-level-programming/P4.png';

export const p4 = {
  mainSection: {
    icon: p4Icon,
    elements: [
      {
        type: 'text',
        items: [
          <>
            P4 is a domain-specific programming language that allows a programmer to arbitrarily decide how the packets
            traversing programmable dataplane blocks are processed.
          </>,
          <></>,
          <>Possible P4 use cases for datacenter networks, enterprise networks and telco networks include:</>,
        ],
      },
      {
        type: 'list',
        items: [
          <>
            <strong>Building flexible leaf-spine fabric:</strong> for instance, based on white box switches that are
            easily reconfigured when needed thanks to the use of a P4-programmable data plane.
          </>,
          <>
            <strong>VNF-offloading:</strong> execute some typical network functions such as a firewall, a NAT or a load
            balancer directly on a programmable HW like a switch or smartNIC in a DC environment.
          </>,
          <>
            <strong>Service chaining:</strong> employ a P4-defined dataplane in the process of creating service chains
            between virtual or physical service appliances (or mixed).
          </>,
          <>
            <strong>Inband Network Telemetry (INT):</strong> use P4 to program a dataplane to gather telemetry metadata
            for each packet. Such data can include packet routing paths, ingress and egress timestamps, latency the
            packet has experienced, queue occupancy in a given node, and egress port link utilization.
          </>,
        ],
      },
    ],
  },
  howWeHelpSection: {
    elements: [
      {
        type: 'list',
        items: [
          <>Consult the use case with the client, focusing on all possible traffic flows to be served within it</>,
          <>
            Verify which P4 architecture model (PSA, V1Model, PISA or other) is supported by a given target (switch,
            smartNIC) and prepare a P4 implementation for this precise model
          </>,
          <>Design the entire dataplane processing pipeline (match-action tables for each control block) using P4</>,
          <>Create a P4 code compilation and build using the tools provided by the target manufacturer</>,
          <>Conduct functional tests of a newly created dataplane</>,
          <>
            Adapt the client’s existing Control/Management software (e.g. SDN controller) to control the given P4-target
            at runtime
          </>,
        ],
      },
    ],
    relatedResources: [
      {
        type: 'Blog post',
        items: [
          {
            title: 'P4 Network Programming Language—what is it all about?',
            link: '/blog/p4-network-programming-language-what-is-it-all-about/',
          },
        ],
      },
      {
        type: 'Video',
        items: [
          {
            title: 'Introduction to network programming with P4',
            link: 'https://www.youtube.com/watch?v=UEMAvXXNWsY&feature=youtu.be',
          },
        ],
      },
    ],
  },
};
